import CheckboxesGroup from '../checkboxesGroup';
import Modal from '../modal';

import './styles.css';

export const Step2ReviewSession = ({
  availableGameTypes,
  onSelectGameType,
  selectedGameTypes,
  onNext,
  selectedGameTypesMinutes
}) => {
  return (
    <Modal>
      <h3>Select Exercises to include in this Review Session?</h3>
      <h4>Est. Time: <span>{selectedGameTypesMinutes}mins</span></h4>
      <CheckboxesGroup
        items={availableGameTypes}
        selectedValues={selectedGameTypes}
        onSelect={onSelectGameType}
      />
      <button className="button onboarding-continue-button" onClick={onNext}>Continue</button>
    </Modal>
  )
};